import { MongibelloForgeUtilities } from "../mongibelloForgeUtilities";

type TranslatableTarget = {
    setText: (value: string) => any;
};
export class LanguageManager {
    // private static instance: LanguageManager;

    private globalVariableManager: any;

    private scene: any;
    private dictGame: { [key: string]: { [key: string]: string } };
    private activeLanguage: string;
    private textObjects: { textObject: TranslatableTarget, key: string }[] = [];
    private gsmBarMessageKey: string;
    private JSON_GAME_DICTIONARY: string;

    private caller: any;
    private mongibelloForgeUtilities: MongibelloForgeUtilities;
    private static supportedLanguages: string[] = ["pt", "en", "es", "it", "sv", "fr"];


    public constructor(scene: any, mongibelloForgeUtilities: any) {
        this.scene = scene;
        this.caller = mongibelloForgeUtilities;
        this.mongibelloForgeUtilities = mongibelloForgeUtilities;

        this.globalVariableManager = (window as any).GlobalVariableManager;

        // load the default language from the paramsData (GET parameters)
        const rawLang = this.globalVariableManager.getGeneralParams().language;
        const langShort = rawLang.split("_")[0]; // da "en_GB" → "en"
        this.JSON_GAME_DICTIONARY = "game";

        this.activeLanguage = LanguageManager.supportedLanguages.indexOf(langShort) !== -1 ? langShort : "en";

        this.dictGame = {};
        this.gsmBarMessageKey = "";
    }

    public setScene(scene: any) {
        this.scene = scene;
    }

    // public static getInstance(scene: any): LanguageManager {
    //     if (!LanguageManager.instance) {
    //         LanguageManager.instance = new LanguageManager(scene);
    //     }
    //     return LanguageManager.instance;
    // }

    public updateActiveLanguage() {
        const rawLang = this.globalVariableManager.getGeneralParams().language;
        const langShort = rawLang.split("_")[0]; // da "en_GB" → "en"
        this.activeLanguage = LanguageManager.supportedLanguages.indexOf(langShort) !== -1 ? langShort : "en";
    }

    public setActiveLanguage(language: string) {
        this.activeLanguage = language;
    }

    public getActiveLanguage(){
        return this.activeLanguage;
    }

    public loadAllLanguages() {
        console.error("Loading all languages...", this.scene);
        LanguageManager.supportedLanguages.forEach((language) => {
            //IL JSON_GAME_DICTIONARY ARRIVA DA GENERICCONSTANT DEL GIOCO
            this.scene.load.json(this.JSON_GAME_DICTIONARY + "_" + language, this.globalVariableManager.getDictionariesPath() + language + "/game.json");
        });
    }

    public initDictionaries() {
        LanguageManager.supportedLanguages.forEach((language) => {
            this.dictGame[language] = this.scene.cache.json.get(this.JSON_GAME_DICTIONARY + "_" + language);
        });
    }

    public getDictGame(){
        return this.dictGame[this.activeLanguage];
    }

    public addTextObject(textObject: TranslatableTarget, key: string | undefined) {
        if (key != undefined) {
            textObject.setText(this.dictGame[this.activeLanguage][key]);
            this.textObjects.push({ textObject: textObject, key: key });
        }
    }

    public removeTextObject(textObject: TranslatableTarget,) {
        this.textObjects = this.textObjects.filter((textObj) => {
            return textObj.textObject !== textObject;
        });
    }

    public updateTextObject(textObject: TranslatableTarget, key: string) {
        this.textObjects.forEach((element) => {
            if (element.textObject === textObject) {
                element.key = key;
                element.textObject.setText(this.dictGame[this.activeLanguage][key]);
            }
        });
    }

    public updateAllTextObjects() {
        this.textObjects.forEach((element) => {
            if (element.key !== undefined) {
                element.textObject.setText(this.dictGame[this.activeLanguage][element.key]);
            }
        });

        this.updateUserbarMessage();
    }

    public updateUserbarMessage() {
        let gsmBarMessage = this.dictGame[this.activeLanguage][this.gsmBarMessageKey];
        if (gsmBarMessage !== undefined) {
            this.mongibelloForgeUtilities.setAndShowBoxText(gsmBarMessage);
        }
    }

    public setUserBarMessage(messageKey: string) {
        this.gsmBarMessageKey = messageKey;
        let gsmBarMessage = this.dictGame[this.activeLanguage][this.gsmBarMessageKey];
        this.mongibelloForgeUtilities.setAndShowBoxText(gsmBarMessage);
    }

    public setCurrentLabelText(messageKey: string) {
        const currentLabelMessage = this.dictGame[this.activeLanguage][messageKey] ?? messageKey;
        return currentLabelMessage;
    }
}
